/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ProductCatalogConfig
 */
export interface ProductCatalogConfig {
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogConfig
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogConfig
     */
    urlTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogConfig
     */
    method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCatalogConfig
     */
    sendBearerToken?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProductCatalogConfig
     */
    parameters?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ProductCatalogConfig interface.
 */
export function instanceOfProductCatalogConfig(value: object): boolean {
    return true;
}

export function ProductCatalogConfigFromJSON(json: any): ProductCatalogConfig {
    return ProductCatalogConfigFromJSONTyped(json, false);
}

export function ProductCatalogConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCatalogConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'urlTemplate': json['urlTemplate'] == null ? undefined : json['urlTemplate'],
        'method': json['method'] == null ? undefined : json['method'],
        'sendBearerToken': json['sendBearerToken'] == null ? undefined : json['sendBearerToken'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function ProductCatalogConfigToJSON(value?: ProductCatalogConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'urlTemplate': value['urlTemplate'],
        'method': value['method'],
        'sendBearerToken': value['sendBearerToken'],
        'parameters': value['parameters'],
    };
}

